import { render, staticRenderFns } from "./AppBarMenu.vue?vue&type=template&id=2f4c6da4&"
import script from "./AppBarMenu.vue?vue&type=script&lang=ts&"
export * from "./AppBarMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports